import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-reading',
    templateUrl: './page-reading.component.html',
    styleUrls: ['./page-reading.component.css'],
    standalone: false
})
export class PageReadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
